export class GlobalNotificationBanner {
    constructor() {
        let hideButtons = document.querySelectorAll("[id*=hide-banner-]");
        if (hideButtons != undefined) {
            hideButtons.forEach(btn => {
                btn.addEventListener('click', function (e) {
                    let bannerId = btn.getAttribute('data-id');
                    let banner = getMatchingBanner(bannerId);
                    banner.classList.add('visually-hidden');
                    updateSessionContext(bannerId);
                })
            });
        }
    }
}

function getMatchingBanner(id: string): HTMLElement {
    let bannerId = "site-banner-" + id;
    return document.querySelector('#' + bannerId);
}

async function updateSessionContext(id: string): Promise<void> {
    await fetch(`/api/v1/notificationBanner/dismissBanner/${id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        }
    });
}
